export const ACTION_LOGIN = 'actionLogin';
export const ACTION_LOGOUT = 'actionLogout';
export const ACTION_BACK_PAGE = 'actionBackPage';
export const SET_LOCATIONS = 'setLocations';
